import React from 'react';
import { commonStyles } from 'utils/designSystem';

const Input = ({ style = {}, ...props }) => {
  return (
    <input
      style={{
        ...commonStyles.input,
        ...style
      }}
      {...props}
    />
  );
};

export default Input;